// extracted by css-extract-rspack-plugin
export default {"root":"TopBar_root__D6uwo","left":"TopBar_left__wDARg","goBackButton":"TopBar_goBackButton__knxa2"};